import api from "./api";

class AdmissionService {
  static getAll(pageNumber, recordsPerPage, dischargedOnly) {
    return api.get(
      `/admission/${dischargedOnly}/${pageNumber}/${recordsPerPage}`
    );
  }

  static getHospitalizationCountries() {
    return api.get("/admission/hospitalizationcountries");
  }

  static filterByHospitalizationCountry(
    hospitalizationCountry,
    pageNumber,
    recordsPerPage
  ) {
    // Handle empty string as "empty" for URL encoding
    const countryParam =
      hospitalizationCountry === ""
        ? "empty"
        : encodeURIComponent(hospitalizationCountry);
    return api.get(
      `/admission/filter/hospitalization-country/${countryParam}/${pageNumber}/${recordsPerPage}`
    );
  }

  static filterByAdmissionDate(fromDate, toDate, pageNumber, recordsPerPage) {
    const fromParam = fromDate || "empty";
    const toParam = toDate || "empty";
    console.log("about to call filter by admission date");
    return api.get(
      `/admission/filter/date/${fromParam}/${toParam}/${pageNumber}/${recordsPerPage}`
    );
  }

  static filterByDischargeDate(fromDate, toDate, pageNumber, recordsPerPage) {
    const fromParam = fromDate || "empty";
    const toParam = toDate || "empty";
    console.log("about to call filter by discharge date");
    return api.get(
      `/admission/filter/discharge-date/${fromParam}/${toParam}/${pageNumber}/${recordsPerPage}`
    );
  }

  static filterByBothDates(admissionFrom, admissionTo, dischargeFrom, dischargeTo, logic, pageNumber, recordsPerPage) {
    const payload = {
      admissionStartDate: admissionFrom || null,
      admissionEndDate: admissionTo || null,
      dischargeStartDate: dischargeFrom || null,
      dischargeEndDate: dischargeTo || null,
      join: logic.toLowerCase(),
      pageNumber: pageNumber,
      recordsPerPage: recordsPerPage
    };
    console.log("about to call filter by both dates with payload:", payload);
    return api.post("/admission/filter/dates", payload);
  }

  static filter(pageNumber, recordsPerPage, textFilter) {
    return api.get(
      `/admission/filter/${textFilter}/${pageNumber}/${recordsPerPage}`
    );
  }

  static getById(id) {
    return api.get(`/admission/${id}`);
  }

  static create(data) {
    return api.post("/admission", data);
  }

  static createAttachment(data) {
    return api.post("/admission/attachment", data);
  }

  static deleteAllAttachments(admissionId) {
    return api.delete(`/admission/AllAttachments/${admissionId}`);
  }
  static deleteAttachment(attachmentId) {
    return api.delete(`/admission/attachment/${attachmentId}`);
  }

  static GetAttachments(admissionId) {
    return api.get(`/admission/Attachments/${admissionId}`);
  }

  static update(id, data) {
    return api.put(`/admission/${id}`, data);
  }

  static delete(id) {
    var response = api.delete(`/admission/${id}`);
    console.log(response, "response");
    return response;
  }

  // Export methods for Excel
  static exportAll(dischargedOnly) {
    return api.get(`/admission/export/${dischargedOnly}`);
  }

  static exportByHospitalizationCountry(hospitalizationCountry) {
    const countryParam =
      hospitalizationCountry === ""
        ? "empty"
        : encodeURIComponent(hospitalizationCountry);
    return api.get(`/admission/export/hospitalization-country/${countryParam}`);
  }

  static exportByDate(fromDate, toDate) {
    const fromParam = fromDate || "empty";
    const toParam = toDate || "empty";
    return api.get(`/admission/export/date/${fromParam}/${toParam}`);
  }

  static exportByBothDates(admissionFrom, admissionTo, dischargeFrom, dischargeTo, logic) {
    const payload = {
      admissionStartDate: admissionFrom || null,
      admissionEndDate: admissionTo || null,
      dischargeStartDate: dischargeFrom || null,
      dischargeEndDate: dischargeTo || null,
      join: logic.toLowerCase()
    };
    console.log("about to call export by both dates with payload:", payload);
    return api.post("/admission/filter/dates?export=true", payload);
  }

  static exportByText(textFilter) {
    return api.get(`/admission/export/${textFilter}`);
  }

  static exportByHospital(hospitalFilter) {
    return api.get(`/admission/export/hospital/${hospitalFilter}`);
  }

  static getByHospital(hospitalFilter, pageNumber, recordsPerPage) {
    return api.get(
      `/admission/filter/hospital/${hospitalFilter}/${pageNumber}/${recordsPerPage}`
    );
  }

  static addNote(admissionId, note) {
    return api.post("/admission/note", {
      admissionId: admissionId,
      note: note,
    });
  }

  static deleteNote(noteId) {
    return api.get(`/admission/note/delete/${noteId}`);
  }

  static getNotes(admissionId) {
    return api.get(`/admission/notes/${admissionId}`);
  }
}

export default AdmissionService;
